import type React from "react"
import { useTranslation } from "react-i18next"

import { downloadCsvNew, downloadXlsxNew } from "@/utils/download"

import { MenuItem } from "@mui/material"

import { getSundayFirstWeekdays } from "./hourly-profile-matrix"
import { hourlyProfileToCsvTable } from "./hourly-profile-to-csv-table"

interface AverageHourlyUsageProfileCsvMenuItemProps {
  averages: (number | null)[][] | undefined
  fileName: string
  weekStartWeekday: number
}

export const AverageHourlyUsageProfileCsvMenuItem: React.FC<
  AverageHourlyUsageProfileCsvMenuItemProps
> = ({ averages, fileName, weekStartWeekday }) => {
  const { i18n, t } = useTranslation("sites")

  const profileTable = () => {
    if (averages == null) {
      return undefined
    }

    return hourlyProfileToCsvTable({
      averages,
      hourOfDayLabel: t("intervalData.hourlyProfile.table.hourOfDay"),
      totalLabel: t("intervalData.hourlyProfile.table.grandTotal"),
      weekStartWeekday,
      weekdays: getSundayFirstWeekdays(i18n.language),
    })
  }

  const handleDownloadCsv = () => {
    const table = profileTable()
    if (table == null) {
      return
    }

    downloadCsvNew(table, fileName)
  }

  const handleDownloadExcel = () => {
    const table = profileTable()
    if (table == null) {
      return
    }

    downloadXlsxNew(table, fileName)
  }

  return (
    <>
      <MenuItem onClick={handleDownloadCsv}>
        {t("menuItem.exportCsv", { ns: "common" })}
      </MenuItem>
      <MenuItem onClick={handleDownloadExcel}>
        {t("menuItem.exportExcel", { ns: "common" })}
      </MenuItem>
    </>
  )
}
